import { render, staticRenderFns } from "./IPAddressesTable.vue?vue&type=template&id=1ad8f1f5&"
import script from "./IPAddressesTable.vue?vue&type=script&lang=js&"
export * from "./IPAddressesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports